/**
 * THE rule for which files count as a supplier's invoice document.
 *
 * One place, because two doors now take that file: Capture Invoice (upload and
 * have it read) and Attach document (upload, read nothing; 2026-09-30). If each
 * kept its own list they would drift, and a file one door accepted the other
 * would refuse -- the person would see the same scan "work" and "fail" on the
 * same screen. Moved here unchanged from InvoiceCaptureModal.validateFile.
 *
 * PDF, Word, Excel and photos or scans. Never only PDF: the wording on screen
 * once said "upload their PDF", which told someone holding a scanned JPG that it
 * did not count.
 */
export const SUPPLIER_DOCUMENT_ACCEPT =
  '.pdf,.doc,.docx,.xlsx,.xls,.png,.jpg,.jpeg,.tiff,.tif,.bmp,.webp';

export const SUPPLIER_DOCUMENT_MAX_BYTES = 50 * 1024 * 1024;

const ALLOWED_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'image/png', 'image/jpeg', 'image/jpg', 'image/tiff', 'image/tif',
  'image/bmp', 'image/webp',
];

const ALLOWED_EXTENSIONS = SUPPLIER_DOCUMENT_ACCEPT.split(',');

/**
 * @param {File|null|undefined} file
 * @returns {string|null} why this file can't be used, or null when it can.
 */
export const supplierDocumentProblem = (file) => {
  if (!file) return 'Please select a file';
  if (!ALLOWED_TYPES.includes(file.type)) {
    // Some browsers send no type for a perfectly good file (a scan off a shared
    // drive, a .doc from an old Office); the name is the fallback.
    const name = (file.name || '').toLowerCase();
    if (!ALLOWED_EXTENSIONS.some((ext) => name.endsWith(ext))) {
      return 'File type not supported. Please upload a PDF, Word document, Excel sheet, or image file.';
    }
  }
  if (file.size > SUPPLIER_DOCUMENT_MAX_BYTES) return 'File size must be less than 50MB';
  return null;
};
